import React from 'react'

export default function ProductsSoldFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        .content-footer-container {
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }
        .add-on-controls {
          font-size: 1.2em;
          display: flex;
          box-sizing: border-box;
          flex: 2;
        }
        .add-on-controls input[type='date'] {
          height: 15px;
          width: 120px;
          padding: 5px;
          text-align: center;
        }
        .add-on-controls #btn-apply {
          padding: 5px;
        }
        .year-nav-button { padding: 5px;}
      `}
      </style>
    </React.Fragment>
  )
}
